import { columnsheadId } from '../../universal/columnshead';
import WebUniversalNewEx, { initDataType, WUExtendPropsType } from '../../system/WebUniversalNewEx';
import AccountantEdit from './AccountantEdit';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import { useEffect, useRef } from 'react';
import { Button, Popconfirm, Switch } from 'antd';
import fetchApi from '../../../utils/api/fetchApi';
import systemConfig from '../../../config/systematic';
import antMessage from '../../../utils/extend/AntdNotification'
import dayjs from 'dayjs';

export default function Accountant(props: any) {
    const apiId = 'accountant';
    const ref = useRef<any>(undefined);
    const { entrepotId, closeModal } = props;
    /** 后端数据Service */
    let wmService: any = systemConfig.wmService;;

    /** 更改一项数据 */
    let handleChangeOne: any;
    //表头
    const columnsHead = [
        {
            title: '期初日期',
            dataIndex: 'startData',
            render: (val: dayjs.ManipulateType) => <span>{dayjs(val).format('YYYY-MM-DD HH:mm:ss')}</span>,
        },
        {
            title: '期末日期',
            dataIndex: 'endData',
            render: (val: dayjs.ManipulateType) => <span>{dayjs(val).format('YYYY-MM-DD HH:mm:ss')}</span>,

        },
        {
            title: '会计名称',
            dataIndex: 'accountantName',

        },
        // {
        //     title: '当期',
        //     dataIndex: 'isCurrent',
        //     render: (text: any, record: any) => (
        //         <Switch checkedChildren="是" unCheckedChildren="否"
        //             checked={text} key={record.id}
        //             onChange={(e) => handleChangeOne(record.id, 'isCurrent', e, apiId)}
        //         />
        //     )

        // },
        {
            title: '结存',
            dataIndex: 'isBalance',
            render: (text: any, record: any) => (
                < Popconfirm placement={"topRight"} title="确定要结存吗？" onConfirm={() => accountantBalance(record.id)
                } okText="确定" cancelText="取消" >
                    <Button size='small' disabled={text} danger>结存</Button>
                </Popconfirm >
            )

        },
        {
            title: '备份',
            dataIndex: 'isBackUp',
            render: (text: any, record: any) => (
                < Popconfirm placement={"topRight"} title="确定要备份吗？" onConfirm={() => accountantBackup(record.id)
                } okText="确定" cancelText="取消" >
                    <Button size='small' disabled={text} danger>备份</Button>
                </Popconfirm >
            )

        },

    ];
    useEffect(() => {
        if (ref.current) {
            handleChangeOne = ref.current.handleChangeOne;

        }
    }, [])

    const accountantBalance = (accountantId: string) => {
        fetchApi.POST(wmService, {
            apiId,
            apiExtend: "accountantBalance",
            apiData: {
                id: accountantId
            }
        }).then((res) => {
            antMessage("success", '结存成功!');
            const currentData: initDataType = {
                apiId,
                sendPageData: { entrepotId }
            }
            ref.current.initData(currentData);


        }).catch((err) => {
            antMessage("error", '失败!', err.message);

        })

    }

    const accountantBackup = (accountantId: string) => {
        fetchApi.POST(wmService, {
            apiId,
            apiExtend: "accountantBackup",
            apiData: {
                id: accountantId
            }
        }).then((res) => {
            antMessage("success", '备份成功!');
            const currentData: initDataType = {
                apiId,
                sendPageData: { entrepotId }
            }
            ref.current.initData(currentData);


        }).catch((err) => {
            antMessage("error", '失败!', err.message);

        })

    }
    const columns = columnsheadId
        .concat(columnsHead as []);

    const handleOk = (e: any) => {
        closeModal(true);
    };
    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '会计',
        apiId,
        showStates: true,
        sendPageData: { entrepotId },
        columns,
        pagination: true,
        EditComponent: AccountantEdit,
    };
    return (
        <>
            <AntDraggableModal
                title={'会计期管理'}
                open={true}
                okText='确定'
                cancelButtonProps={{ style: { display: "none" } }}
                onOk={handleOk}
                closable={false}
                maskClosable={false}
                width={1000}>
                <WebUniversalNewEx ref={ref} props={extendProps}></WebUniversalNewEx>
            </AntDraggableModal>
        </>

    )
}
